"use strict";

exports.__esModule = true;
exports.default = void 0;

var uniqueClasses = function uniqueClasses(list) {
  list = list.split(' ');
  var hash = {};
  var i = list.length;
  var out = [];

  while (i--) {
    if (!hash.hasOwnProperty(list[i])) {
      hash[list[i]] = 1;
      out.unshift(list[i]);
    }
  }

  return out.join(' ');
};

var _default = uniqueClasses;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tanem/svg-injector/lib/unique-classes.js
// module id = 240
// module chunks = 0